$traceurRuntime.ModuleStore.getAnonymousModule(function() {
  "use strict";
  angular.module('app.player', ['ngSanitize', 'ngResource', 'ngAnimate', 'ui.router', 'common.backend', 'templates', 'angular-google-analytics']).config(function($stateProvider, $urlRouterProvider, $httpProvider, AnalyticsProvider) {
    var resolveChannel = (function(name) {
      return ['$stateParams', '$state', 'Backend', 'Toast', (function($stateParams, $state, Backend, Toast) {
        return Backend.joinChannel(name, $stateParams.quiz).catch((function(e) {
          Toast("Die quiz bestaat niet, probeer opnieuw.");
          $state.go('start', {}, {reload: true});
        }));
      })];
    });
    var resolveConfig = ['loadGameConfig', (function(loadGameConfig) {
      return loadGameConfig().then((function(c) {
        return c;
      }));
    })];
    var appResolve = {
      BaseUrl: function() {
        return (typeof localized !== 'undefined' ? localized.assets : '');
      },
      playerChannel: resolveChannel('player'),
      gameConfig: function($http, $q) {
        var myPromise = $q.defer();
        var baseurl = (typeof localized !== 'undefined' ? localized.assets : '');
        var content = baseurl + '/config.json';
        $http.get(content).then(function(response) {
          myPromise.resolve(response.data);
        });
        return myPromise.promise;
      }
    };
    var resolve = {
      playerChannel: resolveChannel('player'),
      gameConfig: resolveConfig
    };
    $stateProvider.state('start', {
      url: "/start",
      templateUrl: "player/start.html",
      controller: 'StartCtrl'
    }).state('main-dispatch', {
      url: '/q/:quiz/dispatch',
      controller: 'DispatchCtrl',
      resolve: appResolve
    }).state('main-message', {
      url: '/q/:quiz/message',
      templateUrl: "player/message.html",
      controller: 'MessageCtrl',
      resolve: appResolve
    }).state('main-question', {
      url: '/q/:quiz/question',
      templateUrl: "player/question-abcd.html",
      controller: 'QuestionCtrl',
      resolve: appResolve
    }).state('main-toggles', {
      url: '/q/:quiz/multiple',
      templateUrl: "player/multiple.html",
      controller: 'MultipleCtrl',
      resolve: appResolve
    }).state('main-question-order', {
      url: '/q/:quiz/question-order',
      templateUrl: "player/question-order.html",
      controller: 'QuestionCtrl',
      resolve: appResolve
    }).state('answer', {
      url: '/answer',
      templateUrl: "player/answer.html",
      controller: 'AnswerCtrl'
    });
    ;
    $urlRouterProvider.otherwise("/start");
  }).run(function($rootScope, Analytics) {});
  ;
  return {};
});

